import { compose } from 'recompose'
import { injectIntl } from 'react-intl'

const AutocompleteContainer = compose(injectIntl)

export default AutocompleteContainer
